import { useEffect, useState } from 'react';
import { useSpring, animated } from 'react-spring';
import { useRaf, useWindowScroll } from 'react-use';

import { Tooltip } from './Tooltip';
import styles from './ButtonUp.module.scss';

export const ButtonUp = () => {
  const [visible, setVisible] = useState(false);
  const [isScrolling, setScrolling] = useState(false);
  const [initialY, setInitialY] = useState(0);
  const { y: scrollY } = useWindowScroll();
  const [time, setTime] = useState(0);
  const done = useRaf(time);
  const { opacity } = useSpring({ opacity: visible ? 1 : 0 });

  useEffect(() => {
    if (isScrolling) {
      window.scroll(0, initialY * (1 - done));
    }
    if (done === 1) {
      setTime(0);
      setInitialY(0);
      setScrolling(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [done]);

  useEffect(() => {
    if (scrollY > 0 && !visible) {
      setVisible(true);
    } else if (scrollY <= 0 && visible) {
      setVisible(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollY]);

  const scrollTop = () => {
    if (!isScrolling) {
      setScrolling(true);
      setInitialY(scrollY);
      setTime(400);
    }
  };

  if (visible === false) {
    return null;
  }

  return (
    <div className={styles.Wrapper}>
      <Tooltip content="Наверх" placement="left">
        <animated.button
          type="button"
          onClick={scrollTop}
          style={{ opacity }}
          className={styles.ButtonUp}
          id="ButtonUp"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 7.5" fill="none" width="18px" height="13px">
            <polygon
              fill="currentColor"
              fillRule="evenodd"
              clipRule="evenodd"
              points="9.03,7.5 5.51,3.97 1.98,7.5 0,5.52 5.51,0 11,5.51 "
            />
          </svg>
        </animated.button>
      </Tooltip>
    </div>
  );
};
